import { Language, Monitor, Smartphone } from "@mui/icons-material";
import { useEffect } from "react";
import styles from "./WhatIDo.module.css";
function WhatIDo() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.slideIn);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    const serviceMiddle = document.querySelector(`.${styles.serviceMiddle}`);
    const serviceElements = document.querySelectorAll(`.${styles.service}`);

    serviceElements.forEach(element => observer.observe(element));
    observer.observe(serviceMiddle);

    return () => {
      observer.disconnect();
    };
  }, []);
  return (
    <section id="services" className={styles.services}>
      <p className={styles.smallP}>What I do</p>
      {/* <h3>
        <strong>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit
        </strong>
      </h3> */}
      <p className={styles.h3}>
        Are you looking for innovative solutions that enhance user experiences
        and drive digital transformation? You've come to the right place. With a
        passion for problem-solving and a keen eye for detail, I specialize in a
        range of services that can elevate your digital presence and empower
        your business.
      </p>
      <div className={styles.serviceList}>
        <div className={`${styles.service}`}>
          <Language className={`${styles.icon}`} />
          <h4>Web Design</h4>
          <p>
            Immerse your audience in captivating online experiences with
            cutting-edge web design. I craft intuitive and visually appealing
            interfaces that engage users from the moment they land on your site.
            Whether it's a sleek corporate platform or an interactive e-commerce
            store, I tailor designs that resonate with your target audience.
          </p>
        </div>
        <div className={`${styles.serviceMiddle}`}>
          <Monitor className={`${styles.iconMiddle}`} />
          <h4>Full Stack Development</h4>
          <p className={styles.serviceMiddleP}>
            From front-end magic to back-end functionality, I excel in full
            stack development that ensures seamless user journeys. I bring
            together the latest technologies to create responsive,
            high-performance web applications that cater to your specific needs.
            With a strong foundation in JavaScript, TypeScript, and more, I
            transform your ideas into reality.
          </p>
        </div>
        <div className={`${styles.service}`}>
          <Smartphone className={`${styles.icon}`} />
          <h4>Mobile Application Development</h4>
          <p>
            In a mobile-first world, having a strong presence on handheld
            devices is crucial. I specialize in crafting mobile applications
            that captivate users on the go. Whether it's iOS or Android, I
            leverage the power of mobile technology to create apps that combine
            aesthetics, functionality, and user-friendliness.
          </p>
        </div>
      </div>
    </section>
  );
}

export default WhatIDo;
